import React from 'react';
import PlusComponent from "../../myComp/PlusComponent";
import ContentView from "../../myComp/ContentView";

class NewsList extends PlusComponent {
  constructor(props) {
    super(props, "contentNews");         
  }

  render(){     
    return (
        <div>
          <ContentView {...this.props} title="News" controller="contentNews"></ContentView>
        </div>
      )
    }
}

export default NewsList;